import React from 'react';
import { Box, ButtonGroup } from '@chakra-ui/react';
import LinkButton from '../../../components/custom/LinkButton';
import AddDepartmentForm from '../../../components/forms/department/AddDepartmentForm';
import PageHeader from '../../../components/common/PageHeader';

export default function AddDepartment() {
    return (
        <>
            <div className='admin-page-header'>
                <PageHeader headerTitle={'部署登録'} />
                <ButtonGroup gap={2}>
                    <LinkButton buttonText={'戻る'} buttonUrl={'/departments'}/>
                </ButtonGroup>
            </div>
            <Box className='admin-box'>
                <AddDepartmentForm />
            </Box>
        </>   
    ) 
}
